import a from "./index49.js";
import p from "./index50.js";
import m from "./index51.js";
import i from "./index52.js";
import f from "./index53.js";
import l from "./index54.js";
import c from "./index55.js";
import d from "./index56.js";
import u from "./index57.js";
import { VERSION as x } from "./index58.js";
import C from "./index59.js";
import A from "./index60.js";
import E from "./index61.js";
import O from "./index62.js";
import S from "./index63.js";
import H from "./index64.js";
import T from "./index65.js";
function n(o) {
  const t = new m(o), e = p(m.prototype.request, t);
  return a.extend(e, m.prototype, t, { allOwnKeys: !0 }), a.extend(e, t, null, { allOwnKeys: !0 }), e.create = function(s) {
    return n(i(o, s));
  }, e;
}
const r = n(f);
r.Axios = m;
r.CanceledError = c;
r.CancelToken = d;
r.isCancel = u;
r.VERSION = x;
r.toFormData = C;
r.AxiosError = A;
r.Cancel = r.CanceledError;
r.all = function(t) {
  return Promise.all(t);
};
r.spread = E;
r.isAxiosError = O;
r.mergeConfig = i;
r.AxiosHeaders = S;
r.formToJSON = (o) => l(a.isHTMLForm(o) ? new FormData(o) : o);
r.getAdapter = H.getAdapter;
r.HttpStatusCode = T;
r.default = r;
const j = r;
export {
  j as default
};
